<vs-dialog #dialog [config]="{ dialogContainerClass: 'max-w-[560px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'alert-triangle',
      iconTheme: 'danger',
      title: 'Delete Party',
      subtitle: subtitle
    }"
  ></vs-dialog-header>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" (click)="cancel()" [disabled]="deleting">Cancel</button>
    <button vs-button theme="danger" class="flex-1" (click)="delete()" [disabled]="deleting">
      <vs-icon slot="start" [class.animate-spin]="deleting" [name]="deleting ? 'refresh-cw-04' : 'trash-01'"></vs-icon>
      {{ deleting ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</vs-dialog>
